import React from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import "./RefreshTokenPopupStyle.scss";
import { TokenDecrypt } from "../Shared/Utils/encryptionDecryption";
import axiosInstance from "../Shared/Utils/axiosInstance";

const RefreshTokenPopup = ({ visible, onHide }) => {
  // Function to handle the continue action
  const logoutUser = () => {
    sessionStorage.removeItem("userToken");
    sessionStorage.removeItem("userRole");
    sessionStorage.removeItem("refreshToken");
    sessionStorage.removeItem("entireToken");
    window.location.href = "/login";
  };
  const handleContinue = async () => {
    try {
      const response = await axiosInstance.post(
        "/api/refreshToken",
        {
          refreshToken: sessionStorage.getItem("refreshToken"),
        }
      );

      const entireToken = response.data;
      const tokenAfterDecrypt = TokenDecrypt(entireToken);
      const idToken = tokenAfterDecrypt.IdToken;

      sessionStorage.setItem("userToken", idToken);

      // You can close the dialog after successful refresh if needed
      onHide();
    } catch (refreshError) {
      console.error("Refresh token failed", refreshError);
      logoutUser();
    }
  };

  // Function to handle the cancel action
  const handleCancel = () => {
    logoutUser();
    onHide();
  };

  return (
    <Dialog
      visible={visible}
      draggable={false}
      modal={true}
      // onHide={onHide}
      closable={false}
      style={{ height: "13rem", width: "30rem" }}
      className="custom-dialog"
    >
      <div className="p-3 border-solid border-200 border-round-lg">
        <div data-testid="session-expired-text"
        className="text-blue-900 font-bold">Session expired. </div>
        <div className="flex mb-5">
          <div className="text-700 text-base" data-testid="continue-session-query">
            Do you want to Continue the session?
          </div>
        </div>
        <div className="p-grid flex p-justify-between justify-content-end gap-5">
          <Button
            label="LogOut"
            data-testid="logout-button"
            style={{
              color: "#999999",
              backgroundColor: "#FFFFFF",
              borderColor: "#999999",
            }}
            onClick={handleCancel}
          />
          <Button
            label="Continue"
            data-testid="continue-button"
            style={{
              borderColor: "#999999",
              backgroundColor: "#E03581",
              fontSize: "16px",
            }}
            onClick={handleContinue}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default RefreshTokenPopup;
